module.exports = __webpack_public_path__ + "img/Oslo.3143a690.svg";